<template>
  <registration-layout ref="form">
    <div v-if="showKlavi">
      <section id="ebs-validation-heading">
        <h2 id="ebs-title">
          {{ $t('pages.reg_ebs.page_title') }}
        </h2>
        <p
          id="ebs-subtitle"
          class="subheading"
        >
          {{ $t('pages.reg_ebs.page_subtitle') }} <a href="https://www.simplic.com.br/blog/conexao-bancaria-para-contratar-emprestimo-simplic-como-fazer/">{{ $t('pages.reg_ebs.subtitle_learn_more') }}</a>.
        </p>
      </section>
      <div class="connection-div">
        <brazil-v-btn
          type="action"
          :loading="klaviButtonLoading"
          @click="klaviOpenBankingButtonClicked"
        >
          {{ $t('pages.reg_ebs.connect') }}
        </brazil-v-btn>
        <div
          v-if="ebsOptional"
          class="refuse-to-connect"
        >
          <div class="brazil-checkbox-field">
            <input
              id="skip_ebs"
              v-model="skipEbs"
              type="checkbox"
            >
            <label for="checkbox">{{ $t('pages.reg_ebs.skip_ebs_checkbox_label') }}</label>
            <brazil-v-tooltip
              tooltip-icon-id="bank_popover"
              title=""
            >
              {{ $t('pages.reg_ebs.skip_ebs_more_info') }}
            </brazil-v-tooltip>
          </div>
          <div class="refuse-to-connect-button">
            <brazil-v-btn
              type="normal"
              depressed
              :disabled="(!skipEbs)"
              :loading="skipButtonLoading"
              @click="skipEBSButtonClicked"
            >
              {{ $t('pages.reg_ebs.refuse_to_connect') }}
            </brazil-v-btn>
          </div>
          <div class="warning">
            <span v-html="$t('pages.reg_ebs.warning_msg')" />
          </div>
        </div>
      </div>
    </div>
    <template v-if="showPhoneVerification">
      <h2 id="phone-verification-title">
        {{ $t('pages.reg_ebs.phone_verification.title') }}
      </h2>
      <p id="phone-verification-instructions">
        {{ $t('pages.reg_ebs.phone_verification.instructions') }}
      </p>
      <phone-verification
        @validatePhoneNumber="handlePhoneVerification"
      />
    </template>
    <ebs-loading v-if="showLoading" />
  </registration-layout>
</template>
<script>
import { get } from 'vuex-pathify';
import RegistrationLayout from '../layouts/RegistrationLayout.vue';
import railsAxios from '../lib/railsAxios';
import captureRenderBlockingException from '../tracking/helpers/captureRenderBlockingException';
import BrazilVBtn from '../components/BrazilVBtn.vue';
import EbsLoading from '../components/EbsLoading.vue';
import BrazilVTooltip from '../components/BrazilVTooltip.vue';
import redirectTo from '../lib/routerHelpers/redirectTo';
import PhoneVerification from '../components/PhoneVerification.vue';
import { trackEvent } from '../lib/optimizely';

export default {
  components: {
    BrazilVBtn,
    RegistrationLayout,
    EbsLoading,
    PhoneVerification,
    BrazilVTooltip,
  },
  props: {
    regStep: {
      default: 'preLoanOffer',
      type:    String,
    },
  },
  data() {
    return {
      klaviRedirect:             this.$route.query.klavi_ebs_status === 'success',
      phoneVerificationComplete: false,
      skipEbs:                   false,
      ebsOptional:               false,
      skipButtonLoading:         false,
      klaviButtonLoading:        false,
    };
  },
  computed: {
    account:         get('account'),
    registration:    get('registration'),
    loanApplication: get('loanApplication'),
    showKlavi() {
      return !this.klaviRedirect;
    },
    showPhoneVerification() {
      return this.klaviRedirect && !this.phoneVerificationComplete;
    },
    showLoading() {
      return this.klaviRedirect && this.phoneVerificationComplete;
    },
  },
  mounted() {
    const currentStep = this.regStep === 'preReg2' ? 2 : 3;
    this.$store.dispatch('registration/setCurrentStepNumber', currentStep);
    this.$router.onReady(this.setup);
  },
  methods: {
    setup() {
      if (this.regStep === 'preLoanOffer') {
        this.checkPhoneVerification();
      }
      this.ebsOptional = this.registration.ebs.ebs_decision === 'ebs_optional';
    },
    handlePhoneVerification(valid) {
      if (valid) {
        this.phoneVerificationComplete = true;
        document.documentElement.scrollTop = 0;
      }
    },
    async klaviOpenBankingButtonClicked() {
      trackEvent('ebs_klavi_button_clicked', this.account.account_id);
      this.klaviButtonLoading = true;
      const response = await railsAxios.get(`/api/klavi-redirect-url/${this.regStep}`);
      const klaviRedirectURL = response.data.klavi_redirect_url;
      window.location.href = klaviRedirectURL;
    },
    async skipEBSButtonClicked() {
      this.skipButtonLoading = true;
      trackEvent('ebs_cancel_button_clicked', this.account.account_id);
      await railsAxios.post('/loan_applications/ebs_not_submitted', {})
        .then((response) => {
          redirectTo(response.data.redirect, this.$route.path);
        })
        .catch((e) => {
          captureRenderBlockingException(e);
          const dest = this.regStep === 'preReg2' ? '/v/pessoal' : '/account_home';
          redirectTo(dest, this.$route.path);
        });
    },
    async checkPhoneVerification() {
      trackEvent('ebs_uw_phone_submitted', this.account.account_id);
      await railsAxios.post('/phone_verification/verification_status', { which_phone: 'main_phone' })
        .then((response) => {
          if (response.data) {
            this.handlePhoneVerification(true);
            trackEvent('ebs_uw_phone_completed', this.account.account_id);
          }
        })
        .catch((e) => {
          captureRenderBlockingException(e);
          trackEvent('ebs_uw_phone_error', this.account.account_id);
        });
    },
  },
};
</script>
<style>
  .credigo-iframe {
    border: 2px solid #f0f0f0;
    border-radius: 2px;
    margin-bottom: 2em;
    box-sizing: content-box;
  }
  .refuse-to-connect {
    max-width: 500px;
    margin: 0 auto;
    padding: 12px 0;
    text-align: center;
  }
  .connection-div {
    max-width: 250px;
    margin: 0 auto;
    text-align: center;
  }
  .refuse-to-connect-button {
    max-width: 250px;
    margin: 0 auto;
    text-align: center;
  }
  .warning {
    display: none;
    color: #6b6b6b;
    padding: 12px 0;
  }
  #phone-verification-title {
    margin-bottom: 0.25em;
  }
  #phone-verification-instructions {
    text-align: center;
  }
</style>
